<div class="p-9">
  <form [formGroup]="userForm">
    <div class="grid grid-cols-1 md:grid-cols-3 gap-4 gap-y-5 !p-4">
      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.AVATAR" | translate}}</label>
      <div class="col-span-2">
        <img
          class="w-[125px] h-[125px] object-cover shadow-xl rounded-xl"
          src="./assets/media/avatars/blank.png"
          alt=""
          srcset=""
        />
      </div>
      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.FULL_NAME" | translate}}</label>

      <div class="col-span-1">
        <input
          pInputText
          [pSize]="'large'"
          class="form-control"
          [fluid]="true"
          type="text"
          formControlName="firstName"
          [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.FIRST_NAME' | translate"
          name="firstName"
          class="form-control mb-3 mb-lg-0"
          [ngClass]="{
            'is-invalid': userForm.controls['firstName'].invalid,
            'is-valid': userForm.controls['firstName'].valid
          }"
        />
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'MANAGE_USERS.FIRSTNAME_REQUIRED' | translate,
            control: userForm.controls['firstName']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'minlength',
            message: 'MANAGE_USERS.FIRSTNAME_MIN' | translate,
            control: userForm.controls['firstName']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'MANAGE_USERS.FIRSTNAME_MAX' | translate,
            control: userForm.controls['firstName']
          }"
        >
        </ng-container>
      </div>
      <div class="col-span-1">
        <input
          pInputText
          [pSize]="'large'"
          class="form-control"
          [fluid]="true"
          formControlName="lastName"
          type="text"
          [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.LAST_NAME' | translate"
          name="lastName"
          [ngClass]="{
            'is-invalid': userForm.controls['lastName'].invalid,
            'is-valid': userForm.controls['lastName'].valid
          }"
        />
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'MANAGE_USERS.LASTNAME_REQUIRED' | translate,
            control: userForm.controls['lastName']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'minlength',
            message: 'MANAGE_USERS.LASTNAME_MIN' | translate,
            control: userForm.controls['lastName']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'MANAGE_USERS.LASTNAME_MAX' | translate,
            control: userForm.controls['lastName']
          }"
        >
        </ng-container>
      </div>
      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.USERNAME" | translate}}
</label>
      <div class="col-span-2">
        <input
          pInputText
          [pSize]="'large'"
          class="form-control"
          [fluid]="true"
          formControlName="username"
          type="text"
          [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.USERNAME' | translate"
          name="username"
          [ngClass]="{
            'is-invalid': userForm.controls['username'].invalid,
            'is-valid': userForm.controls['username'].valid
          }"
        />
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'MANAGE_USERS.USERNAME_REQUIRED' | translate,
            control: userForm.controls['username']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'minlength',
            message: 'MANAGE_USERS.USERNAME_MIN' | translate,
            control: userForm.controls['username']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'MANAGE_USERS.USERNAME_MAX' | translate,
            control: userForm.controls['username']
          }"
        >
        </ng-container>
      </div>
      @if(!showChangePasswordForm){
      <div class="flex flex-col col-span-2">
        <div class="text-base font-semibold mb-1">{{"ACCOUNT_SETTINGS.EDIT_USER.PASSWORD" | translate}}
</div>
        <div class="font-semibold text-gray-600">************</div>
      </div>
      <div class="ms-auto">
        <button
          pButton
          [severity]="'secondary'"
          [size]="'large'"
          (click)="togglePasswordForm(true)"
        >
          {{"ACCOUNT_SETTINGS.EDIT_USER.CHANGE_PASSWORD" | translate}}
        </button>
      </div>
      }@else{

      <hr class="col-span-3" />
      <div class="col-span-3">
        <form
          [formGroup]="passwordForm"
          (ngSubmit)="updatePassword()"
          novalidate=""
        >
          <div class="grid grid-cols-1 md:grid-cols-3 gap-4 gap-y-5 !p-4">
            <div class="col-span-1">
              <label for="password" class="form-label mb-3"
                >{{"ACCOUNT_SETTINGS.EDIT_USER.CURRENT_PASSWORD" | translate}}</label
              >
              <div>
                <input
                  pInputText
                  [pSize]="'large'"
                  class="form-control"
                  [fluid]="true"
                  formControlName="password"
                  type="password"
                  id="password"
                  name="Password"
                  [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.CURRENT_PASSWORD' | translate"
                  [ngClass]="{
                    'is-invalid': passwordForm.controls['password'].invalid,
                    'is-valid': passwordForm.controls['password'].valid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'MANAGE_USERS.PASSWORD_REQUIRED' | translate,
                    control: passwordForm.controls['password']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'minlength',
                    message: 'MANAGE_USERS.PASSWORD_MIN' | translate,
                    control: passwordForm.controls['password']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'maxLength',
                    message: 'MANAGE_USERS.PASSWORD_MAX' | translate,
                    control: passwordForm.controls['password']
                  }"
                >
                </ng-container>
              </div>
              <div class="flex mt-3">
                <button
                  type="submit"
                  pButton
                  severity="secondary"
                  [size]="'large'"
                  class="!px-6 !bg-[#E1E3EA] !text-[#3F4254]"
                  [disabled]="
                    passwordForm.invalid ||
                    passwordForm.get('newPassword')?.value !==
                      passwordForm.get('confirmNewPassword')?.value
                  "
                >
                  {{"ACCOUNT_SETTINGS.EDIT_USER.CHANGE_PASSWORD" | translate}}
                </button>
                <button
                  type="button"
                  pButton
                  [size]="'large'"
                  class="!text-gray-400 !bg-transparent !border-0 !px-6"
                  (click)="togglePasswordForm(false)"
                >
                  {{"ACCOUNT_SETTINGS.EDIT_USER.CANCEL" | translate}}
                </button>
              </div>
            </div>
            <div class="col-span-1">
              <label for="newPassword" class="form-label mb-3"
                >{{"ACCOUNT_SETTINGS.EDIT_USER.NEW_PASSWORD" | translate}}</label
              >
              <div>
                <input
                  pInputText
                  [pSize]="'large'"
                  [fluid]="true"
                  class="form-control"
                  formControlName="newPassword"
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.NEW_PASSWORD' | translate"
                  [ngClass]="{
                    'is-invalid': passwordForm.controls['newPassword'].invalid,
                    'is-valid': passwordForm.controls['newPassword'].valid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'MANAGE_USERS.PASSWORD_REQUIRED' | translate,
                    control: passwordForm.controls['newPassword']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'minlength',
                    message: 'MANAGE_USERS.PASSWORD_MIN' | translate,
                    control: passwordForm.controls['newPassword']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'maxLength',
                    message: 'MANAGE_USERS.PASSWORD_MAX' | translate,
                    control: passwordForm.controls['newPassword']
                  }"
                >
                </ng-container>
              </div>
            </div>

            <div class="col-span-1">
              <label for="confirmpassword" class="form-label mb-3"
                >{{"ACCOUNT_SETTINGS.EDIT_USER.CONFIRM_NEW_PASSWORD" | translate}}</label
              >
              <div>
                <input
                  pInputText
                  [pSize]="'large'"
                  [fluid]="true"
                  class="form-control"
                  formControlName="confirmNewPassword"
                  type="password"
                  id="confirmNewPassword"
                  name="confirmNewPassword"
                  [placeholder]="'ACCOUNT_SETTINGS.EDIT_USER.CONFIRM_NEW_PASSWORD' | translate"
                  [ngClass]="{
                    'is-invalid':
                      passwordForm.controls['confirmNewPassword'].invalid,
                    'is-valid':
                      passwordForm.controls['confirmNewPassword'].valid
                  }"
                />
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'required',
                    message: 'MANAGE_USERS.PASSWORD_REQUIRED' | translate,
                    control: passwordForm.controls['confirmNewPassword']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'minlength',
                    message: 'MANAGE_USERS.PASSWORD_MIN' | translate,
                    control: passwordForm.controls['confirmNewPassword']
                  }"
                >
                </ng-container>
                <ng-container
                  [ngTemplateOutlet]="formError"
                  [ngTemplateOutletContext]="{
                    validation: 'maxLength',
                    message: 'MANAGE_USERS.PASSWORD_MAX' | translate,
                    control: passwordForm.controls['confirmNewPassword']
                  }"
                >
                </ng-container>
                @if( passwordForm.controls['confirmNewPassword'] .errors &&
                passwordForm.controls['confirmNewPassword']
                .errors['confirmNewPassword'] ){
                <div class="fv-plugins-message-container">
                  <div class="fv-help-block">
                    {{'MANAGE_USERS.PASSWORD_MATCH' | translate}}
                  </div>
                </div>
                }
              </div>
            </div>
          </div>
        </form>
      </div>
      <hr class="col-span-3" />
      }

      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.EMAIL" | translate}}</label>
      <div class="col-span-2">
        <input
          pInputText
          [pSize]="'large'"
          class="form-control"
          [fluid]="true"
          formControlName="email"
          type="text"
          [placeholder]="'MANAGE_USERS.EMAIL' | translate"
          name="email"
          autocomplete="off"
          [ngClass]="{
            'is-invalid': userForm.controls['email'].invalid,
            'is-valid': userForm.controls['email'].valid
          }"
        />
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'required',
            message: 'MANAGE_USERS.EMAIL_REQUIRED' | translate,
            control: userForm.controls['email']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'email',
            message: 'MANAGE_USERS.EMAIL_INVALID' | translate,
            control: userForm.controls['email']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'minLength',
            message: 'MANAGE_USERS.EMAIL_MIN' | translate,
            control: userForm.controls['email']
          }"
        >
        </ng-container>
        <ng-container
          [ngTemplateOutlet]="formError"
          [ngTemplateOutletContext]="{
            validation: 'maxLength',
            message: 'MANAGE_USERS.EMAIL_MAX' | translate,
            control: userForm.controls['email']
          }"
        >
        </ng-container>
      </div>
   @if (currentUser?.role === currentRole) {
      <label class="form-label col-span-1"
        ><span class="required">{{"ACCOUNT_SETTINGS.EDIT_USER.ROLE" | translate}}</span></label
      >
      <div class="col-span-2">
        <p-select
          class="form-select"
          [attr.aria-label]="'select role'"
          formControlName="role"
          size="large"
          appendTo="body"
          [fluid]="true"
          [options]="(rolesOptions$ | async) || []"
        />
      </div>  }
      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.ACTIVE" | translate}}</label>
      <div class="col-span-2">
        <div class="flex items-center gap-3">
          <label class="form-label !mb-0"> {{"ACCOUNT_SETTINGS.EDIT_USER.IS_ACTIVE" | translate}} </label>
          <input
            class="form-control"
            formControlName="isActive"
            type="checkbox"
            class="form-check-input"
            id="isActive"
          />
        </div>
      </div>

      <label class="form-label col-span-1">{{"ACCOUNT_SETTINGS.EDIT_USER.EMAIL_DELIVERY_MODE" | translate}}</label>
      <div class="col-span-2">
        <div class="flex items-center gap-3">
          <label class="flex items-center gap-2 !mb-0">
            <input
              type="radio"
              name="emailDeliveryMode"
              value="inApp"
              [checked]="emailDeliveryMode() === 'inApp'"
              (change)="setEmailDeliveryMode('inApp')"
            />
            <span>{{"ACCOUNT_SETTINGS.EDIT_USER.EMAIL_DELIVERY_MODE_SERVER" | translate}}</span>
          </label>
          <label class="flex items-center gap-2 !mb-0">
            <input
              type="radio"
              name="emailDeliveryMode"
              value="outsourceEmail"
              [checked]="emailDeliveryMode() === 'outsourceEmail'"
              (change)="setEmailDeliveryMode('outsourceEmail')"
            />
            <span>{{"ACCOUNT_SETTINGS.EDIT_USER.EMAIL_DELIVERY_MODE_LOCAL" | translate}}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="flex justify-between mt-5">
      <!-- Button to open the modal -->
      <button
        pButton
        severity="danger"
        [size]="'large'"
        class="!px-6 !font-semibold"
        (click)="openConfirmationModal()"
      >
        {{"ACCOUNT_SETTINGS.EDIT_USER.DELETE" | translate}}
      </button>
      <button
        pButton
        severity="success"
        [size]="'large'"
        class="!px-6 !font-semibold"
        (click)="updateUser()"
        [disabled]="userForm.invalid"
      >
        {{"ACCOUNT_SETTINGS.EDIT_USER.UPDATE_USER" | translate}}
      </button>
    </div>
  </form>
  <ng-template
    #formError
    let-control="control"
    let-message="message"
    let-validation="validation"
    >@if(control.hasError(validation) && (control.dirty || control.touched)){

    <div class="fv-plugins-message-container">
      <span role="alert">
        {{ message }}
      </span>
    </div>
    }
  </ng-template>
</div>
<p-confirmdialog key="deleteConfirmDialog" #cd>
  <ng-template #message let-message>
    <div class="flex flex-row items-center w-full gap-4">
      <i [ngClass]="cd.icon" class="!text-3xl !text-danger"></i>
      <p class="font-medium text-xl">{{ (cd.message || '') | translate }}
</p>
    </div>
  </ng-template>
  <ng-template
    pTemplate="footer"
    let-onAccept="onAccept"
    let-onReject="onReject"
  >
    <div class="flex justify-end items-center w-full gap-4">
      <button
        pButton
        [size]="'large'"
        (click)="cd.onAccept()"
        [label]="'MANAGE_USERS.DELETE_USER' | translate"
        class="!bg-danger !text-white !border-0 !font-semibold"
      ></button>
      <button
        pButton
        [size]="'large'"
        (click)="cd.onReject()"
        [label]="'MANAGE_USERS.CANCEL' | translate"
        class="!bg-[#B5B5C3] !text-[#3F4254] !border-0 !font-semibold"
      ></button>
    </div>
  </ng-template>
</p-confirmdialog>
<p-toast position="center"></p-toast>
